/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import { CategoryTableRow } from './CategoryTableRow';

const useStyles = makeStyles({
  root: { width: '100%' },
  container: { maxHeight: 440 },
  table: { minWidth: 600 },
});

const StyledTableCell = withStyles(() => ({
  head: { backgroundColor: '#303474', color: 'white' },
  body: { fontSize: 14 },
}))(TableCell);

// eslint-disable-next-line import/prefer-default-export
export function CategoryTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  searchData,
}) {
  const classes = useStyles();

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = event => setItens(event.target.value);

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="categorias">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell>Nome</StyledTableCell>
              <StyledTableCell>Data de Criação</StyledTableCell>
              <StyledTableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {docs.map(row => (
              <CategoryTableRow key={row.id} docs={row} searchData={searchData} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={total}
        rowsPerPage={itens}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}